import headerImg from '../../../assets/developers/devbanner.svg'

import ease from '../../../assets/developers/ease.svg'
import growth from '../../../assets/developers/growth.svg'
import speed from '../../../assets/developers/speed.svg'

import whyChoose from '../../../assets/developers/whyChoose.svg'


export const headerData = {
    title: 'Reactjs',
    title2: 'Developers',
    desc: 'React JS is an open-source JavaScript library used for building user interfaces (UIs) for web and mobile applications. It allows developers to create reusable UI components and manage the state of an application in a predictable way, making it easier to develop and maintain complex applications.',
    points: [
        'Quick deployment',
        'An active community with open-source solutions',
        'Shorter time-to-market circle',
    ],
    img: headerImg
}

export const achiveData = {
    title1: 'What can you Achieve with the right',
    title2: 'React.js Developers?',
    desc: "You need a React.js team that never compromises on your project’s success determinants. Let's find out what a field-proven team looks like",
    cards: [
        {
            title: 'Growth with Confidence',
            desc: 'Start small but go big with CodeZone’s React.js developers, who leverage seamless and cost-effective cloud computing tools to expand your user base.',
            img: ease
        },
        {
            title: 'Ease of Flexibility',
            desc: 'Node-to-node technology facilitates React.js developers to smoothly integrate changes without altering the core programming source, contributing to easier maintenance.',
            img: growth
        },
        {
            title: 'Speed and Performance',
            desc: 'React.js experts integrate uninterrupted speed and performance to handle high traffic, making React.js an ideal framework for developing user-centric apps.',
            img: speed
        },


    ]
}

export const partnerData = {
    title1: 'Partner With CodeZone for Future-forward',
    title2: 'React JS App Development Services',

    cards: [
        {
            title: 'Truly Agile Procedures',
            desc: "CodeZone's React.js developers follow the time-tested agile practices throughout the software development life cycle — ensuring efficiency and transparency.",
        },
        {
            title: 'Custom React.js development services',
            desc: 'CodeZone is a houseful of React JS experts and tech stack that fit faultlessly with your product and company culture.',
        },
        {
            title: 'Market competitive Rates',
            desc: "We provide silicon-valley level React.js experts under budget-friendly pricing. With us, you wouldn't have to worry about your budget and the quality, because we care for both.",
        },
        {
            title: 'Dedicated React JS Mobile App Development Teams',
            desc: "The dedicated development team co-acts with your in-house team. Borders, languages, or cultures never stop us from delivering a global enterprise-level product.",
        },


    ]
}

export const whyChooseData = {
    title: 'Reactjs',
    desc: 'Easy. Awesome. Powerful. Fast. Flexible. Fun. – All under React.js Umbrella.',
    img: whyChoose,
    cards: [
        {
            title: 'High Performance',
            desc: 'Outperform the competition with the single-threaded and event-driven architecture of React.js.'
        },
        {
            title: 'Easy Scalability',
            desc: 'Handle a huge number of concurrent connections and develop lightweight systems with React.js.'
        },
        {
            title: 'Microservices',
            desc: 'Build powerful microservice-based web applications with React.js developers.'
        },
        {
            title: 'Custom Software Development',
            desc: 'Leverage built-in API through React.js as it can be easily extended and customized.'
        },
        {
            title: 'Fast Time-to-Market',
            desc: 'Speed up the development process with multiple frameworks and libraries of React.js.'
        },
        {
            title: 'Community Support',
            desc: 'Expect extensive support from hawk-eyed developers of the React.js community.'
        },
    ]
}

export const HowToData = {
    title : 'React.js developers',
    desc : 'A meticulous process for impeccable product launch without any delays',
}

export const FAQData = [
    {
        question: 'What is React JS and why is it popular?',
        answer: 'React JS is an open-source JavaScript library used for building user interfaces (UIs) for web and mobile applications. It is popular because it allows developers to create reusable UI components and manage the state of an application in a predictable way, making it easier to develop and maintain complex applications. React also has a large and active community, which provides a wide range of resources, tools, and support.'
    },
    {
        question: 'What are the key features of React JS?',
        answer: 'Some of the key features of React JS include the ability to create reusable UI components, a declarative programming style, a virtual DOM that allows for efficient updates to the UI, and the ability to manage application state in a predictable way.'
    },
    {
        question: 'Is React JS suitable for large-scale applications?',
        answer: "Yes, React JS is suitable for building large-scale applications. Its component-based architecture allows developers to break down complex UIs into smaller, more manageable pieces, making it easier to develop and maintain large-scale applications. Additionally, React's virtual DOM and efficient updates"
    },
 

]